import { render, staticRenderFns } from "./MyAssessment_JianKang.vue?vue&type=template&id=2fe408ae&scoped=true"
import script from "./MyAssessment_JianKang.vue?vue&type=script&lang=js"
export * from "./MyAssessment_JianKang.vue?vue&type=script&lang=js"
import style0 from "./MyAssessment_JianKang.vue?vue&type=style&index=0&id=2fe408ae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fe408ae",
  null
  
)

export default component.exports